import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Container, Typography, Box, Alert, CircularProgress } from '@mui/material';
import { useDispatch } from 'react-redux';

import StoreFormContainer from '../../features/store-market/StoreFormContainer';
import { StoreFormData } from '../../features/store-market/types/store.types';
import { storeService } from '../../features/store-market/services/storeService';
// import { showNotification } from '../../store/slices/notificationSlice';

const CreateStorePage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (storeData: StoreFormData) => {
    setLoading(true);
    
    try {
      console.log('Criando loja com dados:', storeData);
      
      // Simular criação da loja (substitua pela chamada real da API)
      const response = await storeService.createStore(storeData);
      
      alert('Loja criada com sucesso!');
      
      // Redirecionar para a página da loja criada
      navigate(`/stores/${response.data.slug}`);
      
    } catch (error: any) {
      console.error('Erro ao criar loja:', error);
      
      alert(error.message || 'Erro ao criar loja');
    } finally {
      setLoading(false);
    }
  };

  const handleSaveDraft = async (storeData: StoreFormData) => {
    try {
      console.log('Salvando rascunho:', storeData);
      
      // Simular salvamento de rascunho
      // await storeService.saveDraft(storeData);
      
      alert('Rascunho salvo com sucesso!');
      
    } catch (error: any) {
      console.error('Erro ao salvar rascunho:', error);
      
      alert(error.message || 'Erro ao salvar rascunho');
    }
  };

  if (loading) {
    return (
      <Container maxWidth="lg" sx={{ mt: 4, mb: 8 }}>
        <Box
          sx={{
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            justifyContent: 'center',
            minHeight: '400px',
          }}
        >
          <CircularProgress size={60} sx={{ mb: 3 }} />
          <Typography variant="h6" color="text.secondary">
            Criando sua loja...
          </Typography>
          <Typography variant="body2" color="text.secondary">
            Isso pode levar alguns momentos
          </Typography>
        </Box>
      </Container>
    );
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 2, mb: 4 }}>
      {/* Header da página */}
      <Box sx={{ mb: 4, textAlign: 'center' }}>
        <Typography variant="h3" component="h1" gutterBottom color="primary">
          Criar Nova Loja
        </Typography>
        <Typography variant="h6" color="text.secondary" sx={{ maxWidth: 600, mx: 'auto' }}>
          Transforme sua paixão em negócio! Crie sua loja online em poucos passos simples
        </Typography>
      </Box>

      {/* Informações sobre o processo */}
      <Alert severity="info" sx={{ mb: 4 }}>
        <Typography variant="body1" gutterBottom>
          <strong>Como funciona:</strong>
        </Typography>
        <Typography variant="body2" component="div">
          1️⃣ <strong>Informações Básicas:</strong> Nome, descrição e dados de contato da sua loja<br />
          2️⃣ <strong>Produtos:</strong> Adicione os produtos que você quer vender<br />
          3️⃣ <strong>Pagamento:</strong> Configure os métodos de pagamento aceitos<br />
          4️⃣ <strong>Personalização:</strong> Escolha as cores e estilo da sua loja<br />
        </Typography>
        <Typography variant="body2" sx={{ mt: 1 }}>
          💡 <strong>Dica:</strong> Você pode salvar um rascunho a qualquer momento e continuar depois!
        </Typography>
      </Alert>

      {/* Formulário principal */}
      <StoreFormContainer
        onSubmit={handleSubmit}
        onSaveDraft={handleSaveDraft}
      />

      {/* Rodapé com informações adicionais */}
      <Box sx={{ mt: 6, p: 3, bgcolor: 'grey.50', borderRadius: 2 }}>
        <Typography variant="h6" gutterBottom color="primary">
          Precisa de ajuda?
        </Typography>
        <Typography variant="body2" color="text.secondary" paragraph>
          Nossa equipe está aqui para te ajudar a criar a loja dos seus sonhos. 
          Entre em contato conosco através do chat ou email.
        </Typography>
        
        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
          <Typography variant="body2" color="text.secondary">
            📧 suporte@meusacramento.online
          </Typography>
          <Typography variant="body2" color="text.secondary">
            💬 Chat online disponível
          </Typography>
          <Typography variant="body2" color="text.secondary">
            📚 Central de ajuda
          </Typography>
        </Box>
      </Box>
    </Container>
  );
};

export default CreateStorePage;
